// extracted by mini-css-extract-plugin
export default {"header":"XG-z","blueBackground":"YG-z","hfImagesComponent":"ZG-z","containedImage":"_G-z","headerContainer":"aH-z","headerButton":"bH-z"};